import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './promotion_banner.module.css';

const PromotionBanner = ({ url }) => {
  const navigate = useNavigate();

  const goToPage = (e) => {
    e.preventDefault();

    /* try {
      window.makeRequest('/promotion');
    } catch (error) {
      console.log(error);
    } */

    if (url.includes('http')) {
      window.location.replace(url);
    } else {
      navigate(`${url}`);
    }
  };

  return (
    <div className={styles.container} onClick={goToPage}>
      <div className={styles.contentBox}>
        <div className={styles.icon}>
          <img
            src={process.env.PUBLIC_URL + '/imgs/main/icon/check.png'}
            alt=''
          />
        </div>

        <div className={styles.text}>
          매장관리로 바로 가고싶은 점주님은 인터넷 검색창에
          <strong>[우노스페이 매장관리]</strong>를 검색해 주세요.
        </div>
        <div className={styles.arrowIcon}>
          <img src={process.env.PUBLIC_URL + '/imgs/etc/arrow.png'} alt='' />
        </div>
      </div>
      ` `
    </div>
  );
};

export default PromotionBanner;
